// CSpell:ignore Lato
import { Theme } from "@mui/material/styles";

export const chargeRowStyles = {
  display: "flex",
  justifyContent: "space-between",
  mb: 1,
};

export const rateQuoteReviewChargeLabelStyles = {
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "150%",
  letterSpacing: "0.15px",
  color: "text.secondary",
} as const;

export const rateQuoteReviewChargeValueStyles = {
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "150%",
  letterSpacing: "0.15px",
  color: "text.secondary",
  textAlign: "right",
} as const;

/** Figma: Fill width (~511.33px) for rate quote review service cards. */
export const RATE_QUOTE_SERVICE_CARD_MAX_WIDTH_PX = 511.33;

/** Figma: Hug height (58px) for service card header row. */
export const RATE_QUOTE_SERVICE_CARD_HEADER_HEIGHT_PX = 58;

/** Figma: Quote number (e.g. QT-Pending) font size on rate quote review cards. */
export const RATE_QUOTE_SERVICE_CARD_QUOTE_NUMBER_FONT_SIZE_PX = 24;

/** Figma: RECOMMENDED chip dimensions on rate quote review service cards. */
const RATE_QUOTE_RECOMMENDED_CHIP_WIDTH_PX = 84;
const RATE_QUOTE_RECOMMENDED_CHIP_HEIGHT_PX = 24;
const RATE_QUOTE_RECOMMENDED_CHIP_BORDER_RADIUS_PX = 16;
const RATE_QUOTE_RECOMMENDED_CHIP_PADDING_PX = 4;

/** Figma: RECOMMENDED label — 8px / 700 / 266% line-height / uppercase. */
const rateQuoteReviewRecommendedChipLabelStyles = {
  fontFamily: "Lato",
  fontSize: "8px",
  fontWeight: 700,
  lineHeight: "266%",
  letterSpacing: 0,
  textTransform: "uppercase",
  px: 0,
  py: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
} as const;

/** Figma: Light/Success/Main chip container (#2E7D32). */
export const rateQuoteReviewRecommendedChipStyles = (theme: Theme) => ({
  width: `${RATE_QUOTE_RECOMMENDED_CHIP_WIDTH_PX}px`,
  minWidth: `${RATE_QUOTE_RECOMMENDED_CHIP_WIDTH_PX}px`,
  height: `${RATE_QUOTE_RECOMMENDED_CHIP_HEIGHT_PX}px`,
  borderRadius: `${RATE_QUOTE_RECOMMENDED_CHIP_BORDER_RADIUS_PX}px`,
  padding: `${RATE_QUOTE_RECOMMENDED_CHIP_PADDING_PX}px`,
  boxSizing: "border-box" as const,
  fontWeight: 700,
  backgroundColor: theme.palette.customSuccess.main,
  color: theme.palette.common.white,
  "& .MuiChip-label": {
    ...rateQuoteReviewRecommendedChipLabelStyles,
    fontWeight: 700,
    color: theme.palette.common.white,
    padding: 0,
  },
});

export const serviceIconStyles = (theme: Theme) => ({
  fontSize: 28,
  color: theme.palette.grey[600],
});
